<template>
  <v-reports
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="loadData"
    v-bind:data="data"
    show-total
    :totalData="totalData"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
    workgroup-order
  >
    <template #header>
      <v-tabs
        fixed-tabs
        class="v-tabs-slider mt-5"
        height="100"
        icons-and-text
        v-model="mytab"
      >
        <v-tab
          style="border: solid lightgrey 0.5px"
          v-for="(workgroup, index) in workgroups"
          :key="index"
          >{{ workgroup.name }}
        </v-tab>
      </v-tabs>
    </template>
  </v-reports>
</template>

<script>
import Workgroups from "../../mixins/employees/workgroup";

export default {
  name: "workgroup-order-report",
  mixins: [Workgroups],
  data: () => ({
    data_loading: false,
    data: [],
    numPages: 1,
    page: 1,
    params: null,
    mytab: 0,
    total_confirm_complete: 0,
    total_completed: 0,
    totalData: {
      total_actual_cost_sum: 0,
      total_count: 0,
      total_production_cost_sum: 0
    }
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("date"),
          value: "date",
          available: true
        },
        {
          text: this.$t("count"),
          value: "count",
          available: true,
          align: "right"
        },
        {
          text: this.$t("total_actual_cost_sum"),
          value: "total_actual_cost_sum",
          available: true,
          align: "right"
        },
        {
          text: this.$t("total_production_cost_sum"),
          value: "total_production_cost_sum",
          available: true,
          align: "right"
        }
      ];
    }
  },
  watch: {
    page() {
      if (!this.params) return;
      this.loadData(this.params);
    },
    mytab() {
      if (!this.params) return;
      if (this.page != 1) {
        this.page = 1;
        return;
      }
      this.loadData(this.params);
    },
    workgroups: {
      deep: true,
      handler() {
        this.loadData(this.params);
      }
    }
  },
  methods: {
    changePagination(page) {
      this.page = page;
    },
    async loadData(params) {
      this.params = params;
      if (!params) return;
      if (this.workgroups.length == 0) return;
      this.data_loading = true;
      let start_date = new Date(params.start_date).getTime();
      let end_date = new Date(params.end_date).getTime();
      let workgroup_id = this.workgroups[this.mytab]._id;
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_each_report", {
          params: {
            start_time: start_date,
            end_time: end_date,
            limit: 10,
            page: this.page,
            tab: this.mytab,
            workgroup_id: workgroup_id
          }
        })
      );
      if (result && result.data instanceof Array) {
        this.data = result.data;
        this.numPages = Math.ceil(result.total / 10);

        this.totalData = {
          total_actual_cost_sum: result.total_actual_cost_sum,
          total_count: result.total_count,
          total_production_cost_sum: result.total_production_cost_sum
        };
        if (!this.numPages) {
          this.numPages = 1;
        }
      } else {
        this.data = [];
        this.numPages = 1;
        this.page = 1;
        this.totalData = {
          total_actual_cost_sum: 0,
          total_count: 0,
          total_production_cost_sum: 0
        };
      }
      this.data.push({
        date: this.$t("total"),
        count: this.totalData.total_count,
        total_actual_cost_sum: this.totalData.total_actual_cost_sum,
        total_production_cost_sum: this.totalData.total_production_cost_sum
      });
      this.data_loading = false;
    }
  },
  mounted() {}
};
</script>
